import {
  faCircleCheck,
  faEnvelope,
  faPhoneFlip,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { PROVIDER_SUPPORT_PHONE_NUMBER } from "../../../constants";
import { buttonVariants } from "../../design-system/button";
import { cn } from "@verse_core/shared_components/ClassName";

const SUPPORT_EMAIL = "provider-support@versemedical.com";

/** Shown after the sign-up is submitted, with the design's copy. An email that
 * already has an account gets the same response (and a reset email instead), so
 * it lands here too. */
export const DoneStep = () => (
  <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-[48px] tw-pt-[48px] tw-text-center">
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-[24px]">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-[16px]">
        <FontAwesomeIcon
          icon={faCircleCheck}
          aria-hidden="true"
          className="tw-h-[64px] tw-w-[64px] tw-text-verse-text-brand"
        />
        <h1 className="tw-m-0 tw-font-sohne tw-text-[24px] tw-font-light tw-leading-[1.4] tw-tracking-[-0.48px] tw-text-verse-text-brand">
          Your Verse account is ready!
        </h1>
      </div>
      <p className="tw-m-0 tw-font-sohne tw-text-[18px] tw-font-light tw-leading-[1.4] tw-tracking-[-0.18px] tw-text-verse-text-primary">
        You can start placing orders right away while our team verifies your
        account.
      </p>
      <p className="tw-m-0 tw-font-sohne tw-text-[18px] tw-font-light tw-leading-[1.4] tw-tracking-[-0.18px] tw-text-verse-text-primary">
        Please reach out if you have any questions.
      </p>
      <div className="tw-flex tw-flex-col tw-items-start tw-gap-[16px] tw-text-left tw-font-sohne tw-leading-[1.4] tw-text-verse-text-tertiary">
        <div className="tw-flex tw-flex-col tw-gap-[8px] tw-text-[16px]">
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="tw-flex tw-items-center tw-gap-[8px] tw-text-verse-text-tertiary tw-underline hover:tw-text-verse-text-secondary"
          >
            <FontAwesomeIcon
              icon={faEnvelope}
              aria-hidden="true"
              className="tw-h-[16px] tw-w-[16px] tw-text-verse-icon-primary"
            />
            {SUPPORT_EMAIL}
          </a>
          <span className="tw-flex tw-items-center tw-gap-[8px]">
            <FontAwesomeIcon
              icon={faPhoneFlip}
              aria-hidden="true"
              className="tw-h-[16px] tw-w-[16px] tw-text-verse-icon-primary"
            />
            {PROVIDER_SUPPORT_PHONE_NUMBER}
          </span>
        </div>
        <p className="tw-m-0 tw-text-[14px]">
          10:00 AM - 6:00 PM EDT, Monday – Friday.
        </p>
      </div>
    </div>
    <Link
      to="/password-login?type=provider"
      className={cn(
        buttonVariants({ colorScheme: "tide", styleType: "solid", size: "md" }),
        "tw-w-[240px]",
      )}
    >
      Continue
    </Link>
  </div>
);
